import './proximanova_bold_macroman/stylesheet.css';
import './proximanova_regular_macroman/stylesheet.css';
import './proximanova_semibold_macroman/stylesheet.css';
import './proximanova_bolditalic_macroman/stylesheet.css';
import './proximanova_light_macroman/stylesheet.css';
import './proximanova_medium_macroman/stylesheet.css';
import './proximanova_mediumitalic_macroman/stylesheet.css';
import './proximanova_thin_macroman/stylesheet.css';
import './museosansrounded_100_macroman/stylesheet.css';
import './museosansrounded_300_macroman/stylesheet.css';
import './museosansrounded_500_macroman/stylesheet.css';
import './museosansrounded_700_macroman/stylesheet.css';
import './museosansrounded_900_macroman/stylesheet.css';
import './museosansrounded_1000_macroman/stylesheet.css';


// WEBPACK FOOTER //
// ./src/assets/fonts/index.js